export default (theme) => ({
    gridSubContainer: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item:first-child': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:last-child': {
            paddingRight: '0px',
        },
        [theme.breakpoints.down('md')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n)': {
                paddingRight: '0px',
            },
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n + 1)': {
                paddingLeft: '0px',
            },
        },
        '& .MuiGrid-root.MuiGrid-item': {
            padding: '0px',
            [theme.breakpoints.down('md')]: {
                paddingLeft: '12px',
                paddingRight: '12px',
            },
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '0px',
                paddingRight: '0px',
            },
        },
    },
    utmSubContainer: {
        width: '100% !important',
        margin: '0 !important',
        '& .MuiGrid-root.MuiGrid-item': {
            paddingLeft: '12px',
            paddingRight: '12px',
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(3n + 1)': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(3n)': {
            paddingRight: '0px',
        },
        [theme.breakpoints.down('md')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n)': {
                paddingRight: '0px',
                paddingLeft: '12px',
            },
            '& .MuiGrid-root.MuiGrid-item:nth-child(2n + 1)': {
                paddingLeft: '0px',
                paddingRight: '12px',
            },
        },
        [theme.breakpoints.down('sm')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(n)': {
                paddingRight: '0px',
                paddingLeft: '0px',
            },
        },
    },
    addProductSubContainer: {
        width: '100% !important',
        margin: '0 !important',

        '& .MuiGrid-root.MuiGrid-item': {
            paddingLeft: '12px',
            paddingRight: '12px',
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(3n + 1)': {
            paddingLeft: '0px',
        },
        '& .MuiGrid-root.MuiGrid-item:nth-child(3n)': {
            paddingRight: '0px',
        },

        [theme.breakpoints.down('xs')]: {
            '& .MuiGrid-root.MuiGrid-item:nth-child(n)': {
                paddingRight: '0px',
                paddingLeft: '0px',
            },
        },
    },
    productInput: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        '& > div:first-child': {
            width: '100%'
        },
        [theme.breakpoints.down(410)]: {
            width: 'calc(100% - 38px)'
        },
    },
    tableInputFontSize: {
        '& .MuiFormLabel-root': {
            fontSize: '0.875rem',
        },
        '& .MuiInputBase-root': {
            fontSize: '0.875rem',
        },
    },
    tableWrapper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    delivery_row2:{
        padding: 0,
        display: 'flex',
        flexDirection: 'column',

        '& .delivery_row2_item': {
            width: '100%',
            boxSizing: 'border-box',

            [theme.breakpoints.down('md')]: {
                width: '50%',
                '&:first-child': {
                    paddingLeft: '0px',
                    paddingRight: '12px',
                },
                '&:last-child': {
                    paddingLeft: '12px',
                    paddingRight: '0px',
                },
            },

            [theme.breakpoints.down('xs')]: {
                width: '100%',
                '&:nth-child(n)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                },
            },

        },

        [theme.breakpoints.down('md')]: {
            padding: '0px !important',
            flexDirection: 'row',
        },

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    delivery_row2_firstChild: {
        minWidth: '50%',
        boxSizing: 'border-box',
        paddingLeft: '0px',
        paddingRight: '12px',
    },
    delivery_row2_lastChild: {
        minWidth: '50%',
        boxSizing: 'border-box',
        paddingLeft: '12px',
        paddingRight: '0px',
    },

    lastRow_amountTitle: {
        backgroundColor: '#f5f5f5',
        padding: '20px 10px !important',
        '& .MuiTypography-root': {
            fontWeight: 'bold',
        },
    },

    // old styles - ?
    utmTable: {
        width: '100%'
    },
    addRemoveProductAmountRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },

    // order-details style
    order_details_pipeline: {
        [theme.breakpoints.down('sm')]: {
            marginTop: 20,
            border: '2px solid #f5f5f5',
            borderBottom: '1px solid #f5f5f5',
            borderRadius: 5,
        }
    },
    order_details_pipeline_name: {
        fontWeight: 'bold',
        margin: 0,
        width: '100%',
        padding: '10px 0px 16px',

        [theme.breakpoints.down('sm')]: {
            padding: 16,
            borderBottom: '1px solid #f5f5f5',

            '& div:last-child': {
                fontWeight: 'normal',
            },
        }
    },
    order_details_pipeline_row: {
        margin: 0,
        width: '100%',
        padding: '4px 0px',

        [theme.breakpoints.down('sm')]: {
            padding: 16,
            borderBottom: '1px solid #f5f5f5',

            '& div:first-child': {
                fontWeight: 'bold',
            },
        },
    },
    order_settings_grid_item: {
        padding: '0px 5px !important',
    },

})
